<template class="text_google">
  <v-app>
    <v-system-bar class="d-print-none pt-3" height="30" app lights-out>
      <v-toolbar-items class="text-right">
        <v-btn
          large
          rounded
          dark
          href="javascript:window.print()"
          class="title mr-2 rounded"
          color="info"
        >
          <v-icon class="mr-1" color="white" large>mdi-printer</v-icon>พิมพ์
        </v-btn>

        <v-btn
          @click.stop="
            Export2Doc('exportContent', 'คำสั่งรักษาการในตำแหน่ง')
          "
          class="mr-1"
          color="blue"
        >
          <v-icon>mdi-file-word</v-icon>&nbsp; Export to Word
        </v-btn>
        <v-btn
          @click.stop="
            exportToExcel('exportContent', 'คำสั่งรักษาการในตำแหน่ง')
          "
          class="mr-1"
          color="green"
        >
          <v-icon>mdi-file-excel</v-icon>&nbsp; Export to excel
        </v-btn>
      </v-toolbar-items>
    </v-system-bar>
    <div id="exportContent" style="mso-page-orientation: landscape;">
      <div class="page">

        <!-- <div align="center">
          <v-img
            max-height="30mm"
            max-width="25mm"
            src="krud.jpg"
          ></v-img>
          <div class="head">คำสั่งสำนักงานคณะกรรมการการอาชีวศึกษา</div>
          <div class="head">
            ที่ {{  order_appoints.book_number }}
          </div>
          <div class="head">เรื่่อง แต่งตั้งผู้ดำรงตำแหน่ง</div>
          <div class="head">___________________________</div>
          <br />
        </div>
        <div class="a">
          อาศัยอำนาจตามความในมาตรา ๕๓(๕) และมาตรา ๖๘
          แห่งพระราชบัญญัติระเบียบข้าราชการครู และบุคลากรทางการศึกษา พ.ศ.๒๕๔๗
          และที่แก้ไขเพิ่มเติม (ฉบับที่ ๒) พ.ศ.๒๕๕๑ โดยอนุมัติ
          อ.ก.ค.ศ.สำนักงานคณะกรรมการการอาชีวศึกษา ในการประชุมครั้งที่
          {{ order_appoints.meeting_no }} เมื่อวันที่
          {{
            order_appoints.meeting_date
              | moment("add", "543 years")
              | moment("D MMMM YYYY")
          }}

          มีมติอนุมัติให้ย้ายข้าราชการครูและบุคลากรทางการศึกษา ตำแหน่งครู จำนวน
          {{ order_appoints.count_personnel_demand }} ราย
          จึงแต่งตั้งข้าราชการครูและบุคลากรทางการศึกษา ตำแหน่งครู
          ไปแต่งตั้งให้ดำรงตำแหน่งเดิมในสถานศึกษาแห่งใหม่ จำนวน
          {{ order_appoints.count_personnel_demand }} ราย ดังนี้
        </div> -->
        <table
          class="text_j"
          width="100%"
          v-for="(item, index) in conditons_transfer_successs"
          :key="item.id_cts"
        >
          <tr>
            <td class="regular16">
              <div class="a">
                {{ index + 1 }}. {{ item.title_s
                }}{{
                  item.frist_name + "  " + " " + item.last_name
                }}
                &ensp;&ensp; ตำแหน่ง{{ item.ctsname_position }}
                ตำแหน่งเลขที่
                {{ item.ctsid_postion_old }}
                {{ item.college_name_old }}
                ให้ดำรงตำแหน่ง{{ item.ctsname_position }} ตำแหน่งเลขที่
                {{ item.ctsid_position }} {{ item.college_name_new }}
              </div>
            </td>
          </tr>
        </table>
        <table class="" width="100%">
          <tr>
            <td width="10%" colspan="2"></td>
            <td width="90%">
              ทั้งนี้ ตั้งแต่วันที่
              {{
                order_appoints.start_date
                  | moment("add", "543 years")
                  | moment("D MMMM YYYY")
              }}
              เป็นต้นไป
            </td>
          </tr>
        </table>
        <table class="" width="100%">
          <tr>
            <td width="20%"></td>
            <td width="80%">สั่ง ณ วันที่</td>
          </tr>
        </table>

        <p style="page-break-before: always;">&nbsp;</p>



        <div align="center">
          <v-img
            max-height="30mm"
            max-width="25mm"
            src="krud.jpg"
          ></v-img>
          <div class="head">
            (ตัดโอน)       
         <!--  <div class="head">
            ที่ {{  order_appoints.book_number }}
          </div>
          <div class="head">เรื่่อง แต่งตั้งผู้รักษาการในตำแหน่ง</div> -->
          <div class="head">___________________________</div>
          <br />
        </div>
       <!--  <div class="a">
          อาศัยอำนาจตามความในมาตรา ๕๓(๕) และมาตรา ๖๘
          แห่งพระราชบัญญัติระเบียบข้าราชการครู และบุคลากรทางการศึกษา พ.ศ.๒๕๔๗
          และที่แก้ไขเพิ่มเติม (ฉบับที่ ๒) พ.ศ.๒๕๕๑ โดยอนุมัติ
          อ.ก.ค.ศ.สำนักงานคณะกรรมการการอาชีวศึกษา ในการประชุมครั้งที่
          {{ order_appoints.meeting_no }} เมื่อวันที่
          {{
            order_appoints.meeting_date
              | moment("add", "543 years")
              | moment("D MMMM YYYY")
          }}

          มีมติอนุมัติให้ย้ายข้าราชการครูและบุคลากรทางการศึกษา ตำแหน่งครู จำนวน
          {{ order_appoints.count_personnel_transfer }} ราย
          จึงแต่งตั้งข้าราชการครูและบุคลากรทางการศึกษา ตำแหน่งครู
          ไปแต่งตั้งให้ดำรงตำแหน่งเดิมในสถานศึกษาแห่งใหม่ จำนวน
          {{ order_appoints.count_personnel_transfer }} ราย ดังนี้
        </div> -->
        <table
          class="text_j"
          width="100%"
          v-for="(item, index) in conditons_transfer_successsTr"
          :key="item.id_cts"
        >
          <tr>
            <td class="regular16">
              <div class="a">
                {{ index + 1 }}. {{ item.title_s
                }}{{
                  item.frist_name + "  " + " " + item.last_name
                }}
                &ensp;&ensp; ตำแหน่ง{{ item.ctsname_position }}
                ตำแหน่งเลขที่
                {{ item.ctsid_postion_old }}
                {{ item.college_name_old }}
                ให้ดำรงตำแหน่งครู {{ item.ctsname_position }} ตำแหน่งเลขที่
                {{ item.ctsid_position }} {{ item.college_name_new }}
              </div>
            </td>
          </tr>
        </table>
        <table class="" width="100%">
          <tr>
            <td width="10%" colspan="2"></td>
            <td width="90%">
              ทั้งนี้ ตั้งแต่วันที่
              {{
                order_appoints.start_date
                  | moment("add", "543 years")
                  | moment("D MMMM YYYY")
              }}
              เป็นต้นไป
            </td>
          </tr>
        </table>
        <table class="" width="100%">
          <tr>
            <td width="20%"></td>
            <td width="80%">สั่ง ณ วันที่</td>
          </tr>
        </table>


      </div>
    </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    ApiKey: "HRvec2021",
    order_appoints: [],
    conditons_transfer_successs: [],
    conditons_transfer_successsTr: [],
    valid: true,
    textContent: ""
  }),

  async mounted() {
    await this.sweetAlertLoading();
    await this.order_appointQueryAll();
    await this.conditons_transfer_successQueryAll();
    await this.conditons_transfer_successTrQueryAll();
    await this.order_appoint_num();
    Swal.close();
  },

  methods: {
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    async order_appointQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("order_appoint.php", {
          ApiKey: this.ApiKey,
          id_oa: this.id_url
        })
        .finally(() => (this.loading = false));
      this.order_appoints = result.data;
    },

    async order_appoint_num() {
      this.loading = true;
      let result = await this.$http
        .post("order_appoint.php", {
          ApiKey: this.ApiKey,
          id_oa: this.id_url
        })
        .finally(() => (this.loading = false));
      this.order_appoints = result.data;
    },

    async conditons_transfer_successQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("conditons_transfer_success_okks.php", {
          ApiKey: this.ApiKey,
          time_s: this.order_appoints.time_s,
          year_s: this.order_appoints.year_s,
          name_position: "ครู",
          ctsstatus_selectfrist: "ok"
        
        })
        .finally(() => (this.loading = false));
      this.conditons_transfer_successs = result.data;
    },

    async conditons_transfer_successTrQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("conditons_transfer_success_okks.php", {
          ApiKey: this.ApiKey,
          time_s: this.order_appoints.time_s,
          year_s: this.order_appoints.year_s,
          name_position: "ครู",
          ctsstatus_selectsecord: "transfer"
        
        })
        .finally(() => (this.loading = false));
      this.conditons_transfer_successsTr = result.data;
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    },
    exportToExcel(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Excel</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msexcel"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-excel;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".xls" : "document.xls";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    }
  },
  props: {
    source: String
  },

  computed: {
    url_result() {
      let result = window.location.href;
      let split_s = result.split("/");
      return split_s[6];
    },

    position_url() {
      let result = this.url_result.slice(6);
      if (result == "teach") {
        result = "ครู";
      } else {
        result = "บริหาร";
      }
      return result;
    },
    id_url() {
      let result = this.url_result;
      return result[0];
    },
    check_time() {
      let result = this.order_appoints.meeting_no;
      let timess;
      if (isNaN(result)) {
        timess = 0;
      } else {
        timess = 1;
      }
      return timess;
    }
  }
};
</script>
<style>
@import url(
  https://fonts.googleapis.com/css?family=Prompt:400,
  300|Roboto:400,
  300&subset=latin,
  thai
);

body {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}
div.a {
  text-indent: 50px;
  line-height: 1;
  text-align: justify;
  text-justify: inter-word;
}
.textAlignVer {
  display: block;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  transform: rotate(-90deg);
  position: relative;
  width: 20px;
  white-space: nowrap;
  font-size: 14px;
  margin-bottom: 5;
}

u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}

* {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.table,
.th,
.td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
  line-height: 1;
}

tfoot tr:hover {
  background-color: initial;
}

tbody tr:hover {
  background-color: inherit;
}

td,
th {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
}

tfoot td {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-weight: bold;
}

#verticaltext {
  writing-mode: tb-rl;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  white-space: nowrap;
  display: block;
  overflow: hidden;
  padding: 0;
}

.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: 21cm;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 0cm;
  margin-right: auto;
  margin-bottom: 0cm;
  margin-left: auto;
  padding-top: 1cm;
  padding-right: 1.5cm;
  padding-bottom: 1cm;
  padding-left: 1.5cm;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
  line-height: 1;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blod12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 12pt;
}

.blackBold18 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 18pt;
  font-weight: bold;
}

.largerCheckbox {
  width: 30px;
  height: 30px;
  color: blue;
}
.td_line {
  border-bottom: 1pt dotted black;
}
/*.subpage {
    height: 247mm;
  }*/

.BlackBold10 {
  font-weight: bold;
}

#content {
  display: table;
}

#pageFooter {
  display: table-footer-group;
}

#pageFooter:after {
  counter-increment: page;
  content: counter(page);
}

@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding-top: 1cm;
    padding-right: 1cm;
    padding-bottom: 1cm;
    padding-left: 1.5cm;
  }

  .head {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  .regular12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .regular16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .bold16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blod12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blackRegula10 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 14pt;
  }

  .blackBold18 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  /* .head {
      font-size: 18px;
      font-weight: bold;
    }
    .regular12 {
      font-size: 12px;
    }
    .blod12 {
      font-size: 12px;
      font-weight: bold;
    }
    .blackRegula8 {
      font-size: 8px;
    } */
  .noprint {
    display: none;
  }
}
</style>
